
import Http from "../../http/client";

export default async (id, payload) => {
  const response = await Http.patch('trip/price/'+id, payload);
  return response.data;
}
